if (!customElements.get('sangdouleur-cart-drawer-upsell-slider')) {
  customElements.define(
    'sangdouleur-cart-drawer-upsell-slider',
    class SangdouleurCartDrawerUpsellSlider extends HTMLElement {
      connectedCallback() {
        this.slider = this.querySelector('[data-upsell-slider]');
        if (!this.slider) return;

        this.items = Array.from(this.slider.querySelectorAll('.sangdouleur-cart-drawer__upsell-item'));
        this.prevButton = this.querySelector('[data-upsell-prev]');
        this.nextButton = this.querySelector('[data-upsell-next]');

        this.isolateAddButtons();

        if (this.items.length <= 1) {
          this.prevButton?.remove();
          this.nextButton?.remove();
          return;
        }

        this.slider.dataset.multi = 'true';
        this.currentIndex = 0;
        this.dragged = false;

        this.onScroll = this.updateNavState.bind(this);
        this.slider.addEventListener('scroll', this.onScroll, { passive: true });

        this.prevButton?.addEventListener('click', () => this.goTo(this.currentIndex - 1));
        this.nextButton?.addEventListener('click', () => this.goTo(this.currentIndex + 1));

        this.initPointerDrag();
        this.updateNavState();
      }

      disconnectedCallback() {
        this.slider?.removeEventListener('scroll', this.onScroll);
      }

      isolateAddButtons() {
        this.querySelectorAll('.sangdouleur-cart-drawer__upsell-button').forEach((button) => {
          ['pointerdown', 'mousedown', 'click'].forEach((eventName) => {
            button.addEventListener(eventName, (event) => {
              event.stopPropagation();
            });
          });
        });
      }

      goTo(index) {
        const clamped = Math.max(0, Math.min(index, this.items.length - 1));
        const item = this.items[clamped];

        if (!item) return;

        this.slider.scrollTo({
          left: item.offsetLeft,
          behavior: 'smooth',
        });
      }

      updateNavState() {
        const scrollLeft = this.slider.scrollLeft;
        let closestIndex = 0;
        let closestDistance = Infinity;

        this.items.forEach((item, index) => {
          const distance = Math.abs(item.offsetLeft - scrollLeft);
          if (distance < closestDistance) {
            closestDistance = distance;
            closestIndex = index;
          }
        });

        this.currentIndex = closestIndex;

        if (this.prevButton) {
          this.prevButton.disabled = closestIndex === 0;
        }

        if (this.nextButton) {
          this.nextButton.disabled = closestIndex >= this.items.length - 1;
        }
      }

      snapToClosest() {
        this.updateNavState();
        this.goTo(this.currentIndex);
      }

      isInteractiveTarget(target) {
        return Boolean(
          target?.closest(
            'button, a, input, textarea, select, product-form, label, .sangdouleur-cart-drawer__upsell-button'
          )
        );
      }

      initPointerDrag() {
        let isPointerDown = false;
        let startX = 0;
        let scrollLeft = 0;

        const onPointerDown = (event) => {
          if (event.pointerType !== 'mouse') return;
          if (event.button !== 0) return;
          if (this.isInteractiveTarget(event.target)) return;

          isPointerDown = true;
          this.dragged = false;
          startX = event.clientX;
          scrollLeft = this.slider.scrollLeft;
          this.slider.classList.add('is-dragging');

          if (this.slider.setPointerCapture) {
            try {
              this.slider.setPointerCapture(event.pointerId);
            } catch (error) {
              /* noop */
            }
          }
        };

        const onPointerMove = (event) => {
          if (!isPointerDown) return;

          const delta = event.clientX - startX;

          if (Math.abs(delta) > 8) {
            this.dragged = true;
          }

          this.slider.scrollLeft = scrollLeft - delta;
        };

        const endPointer = () => {
          if (!isPointerDown) return;

          isPointerDown = false;
          this.slider.classList.remove('is-dragging');

          if (this.dragged) {
            this.snapToClosest();
            window.setTimeout(() => {
              this.dragged = false;
            }, 0);
          }
        };

        this.slider.addEventListener('pointerdown', onPointerDown);
        this.slider.addEventListener('pointermove', onPointerMove);
        this.slider.addEventListener('pointerup', endPointer);
        this.slider.addEventListener('pointercancel', endPointer);

        this.slider.addEventListener(
          'click',
          (event) => {
            if (!this.dragged) return;
            if (this.isInteractiveTarget(event.target)) return;

            event.preventDefault();
            event.stopPropagation();
          },
          true
        );
      }
    }
  );
}
